var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Footer',{staticClass:"footer-container"},[_c('p',[_vm._v(" Copyright © Insite Digital Limited "+_vm._s(new Date().getFullYear())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }